import { render } from "./PrintSummary.vue?vue&type=template&id=2771843e"
import script from "./PrintSummary.vue?vue&type=script&lang=js"
export * from "./PrintSummary.vue?vue&type=script&lang=js"

import "./PrintSummary.vue?vue&type=style&index=0&id=2771843e&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__